module.exports = {"title":"알림 발송","sendDate":"발송 일시","sendStatus":"발송 상태","recipients":"수신 인원","target":"대상","alarmType":"알림 종류","smsContent":"SMS 내용","emailTitle":"이메일 제목","emailContent":"이메일 내용","registeredDate":"등록/수정일시","editButton":"수정하기","resend":"재발송","none":"없음","scheduled":"발송 예정","sending":"발송중","failed":"발송 실패","completed":"발송 완료","resendConfirm":"해당 알림을<br />지금 재발송 하시겠습니까?","resendInProgress":"알림 재발송이 진행됩니다.","errorRetry":"오류가 발생했습니다.<br />다시 시도해주세요."}


//////////////////
// WEBPACK FOOTER
// ./src/locales/ko/se202.json
// module id = ekok
// module chunks = 2